export default __webpack_public_path__ + "static/media/christmas-2025.e95a5653.png";